import { render, staticRenderFns } from "./StickyTabs.vue?vue&type=template&id=46931980&"
import script from "./StickyTabs.vue?vue&type=script&lang=js&"
export * from "./StickyTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports